<template>
  <case-update-card
    :info-item="decision"
    :icon="'mdi-bookshelf'"
    :header="decisionHeader"
    :code-display-name="local.caseFile.cards.decision.codeDisplayName"
    :code="decision.decesionCode"
    :status=" decision.decisionStatus"
    :status-display-name="local.caseFile.cards.decision.statusDisplayName"
    :date="decision.decisionDate"
    :date-display-name="local.caseFile.cards.decision.dateDisplayName"
    :has-actions="true"
    :court-name="decision.courtName"
    :sub-circle-name="decision.subCircleName"
    @card-click="$emit('decision-card-click',decision)"
  >
  </case-update-card>
</template>

<script>
import { toHijriDate, getTimePart } from '@/helpers/utils';
import CaseUpdateCard from './case-update-card.vue';
import { decisionTypeEnum } from '@/helpers/enum';

export default {
  name: 'DecisionCard',
  components: { CaseUpdateCard },
  props: {
    decision: {
      type: Object,
      required: true,
    },
  },
  computed: {
    decisionHeader() {
      switch (this.decision.decisionTypeId) {
        case decisionTypeEnum.supremeCourtDecision:
          return `${this.local.caseFile.cards.decision.resultDisplayName}  ${this.decision.decisionType}`;
        default:
          return this.decision.decisionType;
      }
    },
  },
  methods: {
    toHijriDate,
    getTimePart,
  },
};

</script>

<style scoped>
.header-text {
  font-size: 18px;
}

::v-deep .case-update-card-header {
  color: var(--app-dark-primary-color);
  font-size: 25px;
}
</style>
